"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadPhotoSchema = exports.UPLOAD_PHOTO_STATUS = void 0;
var zod_1 = require("zod");
exports.UPLOAD_PHOTO_STATUS = {
    /** 사진 로드 완료 */
    LOADED: 'LOADED',
    /** 사진 업로드 완료 */
    UPLOAD_SUCCESS: 'UPLOAD_SUCCESS',
    /** 사진 업로드 실패 */
    UPLOAD_FAILED: 'UPLOAD_FAILED',
};
var LoadedSchema = zod_1.z.object({
    status: zod_1.z.literal(exports.UPLOAD_PHOTO_STATUS.LOADED),
});
var UploadSuccessSchema = zod_1.z.object({
    url: zod_1.z.string(),
    status: zod_1.z.literal(exports.UPLOAD_PHOTO_STATUS.UPLOAD_SUCCESS),
});
var UploadFailedSchema = zod_1.z.object({
    status: zod_1.z.literal(exports.UPLOAD_PHOTO_STATUS.UPLOAD_FAILED),
});
exports.UploadPhotoSchema = zod_1.z.union([LoadedSchema, UploadSuccessSchema, UploadFailedSchema]);
